import Topbar from '../components/Topbar';
import Dashboard from '../Pages/Dashboard';
import Rai from '../Pages/Rai';
import Leaderboard from '../Pages/Leaderboard';
import PromptLibrary from '../Pages/PromptLibrary';
import PromptPlayground from '../Pages/PromptPlayground';
import useLoading from '../hooks/useLoading';
import FinOps from '../Pages/FinOps';
import ContextProvider from '../context/ContextProviders';
import Onboarding from '../Pages/Onboarding';
import MyApps from '../Pages/MyApps';
import ManageAppRequests from '../Pages/ManageAppRequests';
import Sidebar from '../components/Sidebar';
import React, { useState } from 'react';
import ModelOnboarding from '../Pages/ModelOnboarding/ModelOnboarding';
import SystemAnalytics from '../Pages/Analytics/SystemAnalytics';
import CostAnalytics from '../Pages/CostAnalytics';
import AddPrompt from '../components/AddPrompt/AddPrompt';
import ModelLibrary from '../Pages/ModelLibrary/ModelLibrary';
import RagBuilder from '../Pages/RagBuilder/RagBuilder';
import NewRagForm from '../components/Rag/NewRagForm';
import PromptPlaygroundCompare from '../Pages/PromptPlaygroundCompare';
import UnileverAnimation from '../components/UnileverAnimation';
import Ethics_ComplainceAnalytics from '../Pages/Analytics/Ethics_ComplainceAnalytics';
import ManageRag from '../Pages/RagBuilder/ManageRag';
import HealthAnalytics from '../Pages/Analytics/HealthAnalytics';
import UnifiedAnalytics from '../Pages/Analytics/UnifiedAnalytics';

const AiFoundation = (props: any) => {
  const [collapsed, setCollapsed] = useState(false);

  const isLoading = useLoading();
  const renderPage = () => {
    switch (props.page) {
      case 'finops':
        return <FinOps />;
      case 'leaderboard':
        return <Leaderboard />;
      case 'promptlibrary':
        return <PromptLibrary />;
      case 'promptplayground':
        return <PromptPlayground />;
      case 'comparePrompts':
        return <PromptPlaygroundCompare />;
      case 'rai':
        return <Rai />;
      case 'onboarding':
        return <Onboarding />;
      case 'myapps':
        return <MyApps />;
      case 'manageapprequests':
        return <ManageAppRequests />;
      case 'ragbuilder':
        return <RagBuilder />;
      case 'newragform':
        return <NewRagForm />;
      case 'managerag':
        return <ManageRag />;
      case 'costAnalytics':
        return <CostAnalytics />;
      case 'modelOnboarding':
        return <ModelOnboarding />;
      case 'systemanalytics':
        return <SystemAnalytics />;
      case 'ethicscompliance':
        return <Ethics_ComplainceAnalytics />;
      case 'healthdashboard':
        return <HealthAnalytics />;
      case 'unifiedanalytics':
        return <UnifiedAnalytics />;
      case 'addPrompt':
        return <AddPrompt />;
      case 'model':
        return <ModelLibrary />;
      case 'dashboard':
      default:
        return <Dashboard />;
    }
  };
  if (isLoading)
    return (
      <div
        style={{ height: '100vh' }}
        className="container-fluid d-flex justify-content-center align-items-center bg-white">
        {/* <h4 className="text-center">Loading... 1</h4> */}
        <UnileverAnimation />
      </div>
    );

  return (
    <>
      <div className="container-fluid p-0 d-flex flex-column min-vh-100">
        <Topbar />
        <ContextProvider>
          <div className="d-flex" style={{ marginTop: 60 }}>
            <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
            <main
              className="flex-grow-1"
              style={{
                marginLeft: collapsed ? '70px' : '257px',
                height: 'calc(100vh - 63px)',
                overflowY: 'auto',
                backgroundColor: '#FFFFFF',
                paddingTop: '10px',
                overflowX: 'hidden'
              }}>
              {renderPage()}
            </main>
          </div>
        </ContextProvider>
      </div>
    </>
  );
};

export default AiFoundation;
